<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="filter_container">
      <div class="handler">
        <el-tabs
          class="tab"
          v-model="currentCard"
          size="small"
          type="card"
          @tab-click="handleClick"
        >
          <!--班级附件类型(1 线上班级、2 入学通知书、3 培训计划、4 各工作小组及人员名单、5 学员管理规定、6 学员须知、7 生活服务提示、8 党校平面图)-->
          <el-tab-pane label="培训计划" name="3"></el-tab-pane>
          <el-tab-pane label="日程安排" name="1"></el-tab-pane>
          <el-tab-pane label="各工作小组及人员名单" name="4"></el-tab-pane>
          <el-tab-pane label="学员管理规定" name="5"></el-tab-pane>
          <el-tab-pane label="学员须知" name="6"></el-tab-pane>
          <el-tab-pane label="生活服务提示" name="7"></el-tab-pane>
          <el-tab-pane label="党校平面图" name="8"></el-tab-pane>
        </el-tabs>

        <el-button
          class="trash"
          title=""
          type="primary"
          size="small"
          @click="$router.push({path: '/offlineClass'})"
          icon="el-icon-arrow-left"
          >返回</el-button
        >
      </div>
    </div>
    <!--文件-->
    <div class="teaching_page" v-if="currentCard !== '1'">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="100px"
        class="form"
      >
        <el-form-item class="content" :label="labelMsg" prop="attachmentList" >
          <upload
            ref="upload"
            :limit="1"
            :accepts="acceptsType"
            :path="'class/attachment'"
            v-model="ruleForm.attachmentList"
          />
        </el-form-item>
        <el-form-item v-if="attachmentDetail.fileName">
          <div class="fileName" v-if="currentCard !== '8'">
            {{attachmentDetail.fileName}}
            <a class="preview_text" :href="attachmentDetail.url" target="_blank">预览</a>
          </div>
          <div class="fileName" v-else>
            {{attachmentDetail.fileName}}
            <span class="preview_text" @click="showBigImage = true">预览</span>
            <el-image-viewer
              v-if="showBigImage"
              :on-close="closeViewer"
              :url-list="[attachmentDetail.url]"
            />
          </div>
        </el-form-item>
        <el-form-item style="text-align: center;">
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--日程安排-->
    <DailySchedule v-else-if="currentCard == '1'"/>
    <template v-else />
  </div>
</template>
<script>
import DailySchedule from "./dailySchedule/index";
import Upload from "@/components/upload/index";
import { fileLibraryUpload } from "@/api/fileLibrary";
import {
  fileLibraryPage
} from "@/api/fileLibrary";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  name: "offlineClassTeaching",
  components: {
    DailySchedule,
    Upload,
    ElImageViewer
  },
  data() {
    return {
      labelMsg: "培训计划",
      attachmentDetail: {},
      ruleForm: {
        attachmentList: []
      },
      rules: {
        attachmentList: [
          {
            required: true,
            message: "请上传文件"
          }
        ]
      },
      classId: "",
      currentCard: "3",
      acceptsType: ['pdf'],
      showBigImage: false,
    };
  },
  created() {
    this.classId = this.$route.query.id;
    this.currentCard = this.$route.query.currentCard || "3";
    this.getFileLibraryPage();
  },
  methods: {
    closeViewer() {
      this.showBigImage = false;
    },
    handleClick(tab) {
      // 班级附件类型(1 线上班级、2 入学通知书、3 培训计划、4 各工作小组及人员名单、5 学员管理规定、6 学员须知、7 生活服务提示、8 党校平面图)
      switch(tab.name) {
        case "1":
          this.labelMsg = "日程安排";
          break;
        case "3":
          this.labelMsg = "培训计划";
          break;
        case "4":
          this.labelMsg = "各工作小组及人员名单";
          break;
        case "5":
          this.labelMsg = "学员管理规定";
          break;
        case "6":
          this.labelMsg = "学员须知";
          break;
        case "7":
          this.labelMsg = "生活服务提示";
          break;
        case "8":
          this.labelMsg = "党校平面图";
          break;
        default:
          this.labelMsg = "日程安排";
          break;
      }
      if (tab.name == '8') {
        this.acceptsType = ['jpg','png'];
      } else this.acceptsType = ['pdf'];

      this.ruleForm.attachmentList = [];
      this.$nextTick(() => {
        if (tab.name !== '1') {
          this.getFileLibraryPage();
        }
      });
    },
    // 班级附件类型(1 线上班级、2 入学通知书、3 培训计划、4 各工作小组及人员名单、5 学员管理规定、6 学员须知、7 生活服务提示、8 党校平面图)
    getFileLibraryPage() {
      fileLibraryPage({ classId: this.classId, bizType: this.currentCard }).then(({ code, data }) => {
        if (code === 0) {
          this.attachmentDetail = data.records[0] || {};
        }
      });
    },
    onSubmit() {
      if (this.ruleForm.attachmentList.length > 0) {
        this.loading = true;
        let params = {
          classId: this.classId,
          bizType: this.currentCard,
          uuid: this.attachmentDetail.uuid ? this.attachmentDetail.uuid : ''
        };
        params["attachment"] = JSON.stringify(this.ruleForm.attachmentList);
        fileLibraryUpload(params).then(res => {
          this.loading = false;
          if (res && res.code == 0) {
            this.getFileLibraryPage();
            this.$refs["ruleForm"].resetFields();
            this.$message.success(res.msg);
          }
        });
      } else return;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.teaching_page .el-form-item__content {
  margin-left: 116px !important;
}
.content {
  width: 50%;
}
.filter_container {
  padding-bottom: 15px !important;
}
.fileName {
  font-size: 12px;
  .preview_text {
    color: #3A85FF;
    margin-left: 18px;
    text-decoration: none;
  }
}
.handler {
  position: relative;
  .tab {
    width: 100%;
  }
  .trash {
    position: absolute;
    right: 0;
    top: 5px;
  }
}
</style>
